import { postRequest } from "../apiRequest";
import { apiRoutes } from "../Constants/ApiRoutes";

/**
 * Log AI answer like/dislike to backend for Kibana. Fire-and-forget; does not throw.
 * @param {{ feedbackType: string, searchQuery: string, responseText?: string, responsePosition?: number, isFollowUp?: boolean, sessionId?: string }} params
 */
export async function submitAiAnswerFeedback({
    feedbackType,
    searchQuery = "",
    responseText = "",
    responsePosition = 0,
    isFollowUp = false,
    sessionId = "",
}) {
    const normalized = feedbackType === "dislike" ? "dislike" : "like";
    const body = {
        feedback_type: normalized,
        search_query: (searchQuery || "").slice(0, 500),
        response_text: (responseText || "").slice(0, 1000),
        response_position: responsePosition,
        is_follow_up: isFollowUp,
    };
    if (sessionId) body.session_id = sessionId;
    try {
        await postRequest(apiRoutes.kbArticleAiAnswerFeedback, body);
    } catch (_) {
        // Log only; do not block UI or Gainsight
    }
}

/** Normalize to array; accept single object or alternate keys. */
function normalizeSources(data) {
    const raw = data.sources ?? data.source ?? data.references ?? data.source_list ?? [];
    if (Array.isArray(raw)) return raw;
    if (raw && typeof raw === "object" && !Array.isArray(raw)) return [raw];
    return [];
}

/** Build source entry from a search result (fullPath or categorySlug/slug). */
function searchResultToSource(item, index) {
    const url = item.fullPath
        ? (item.fullPath.startsWith("/") ? item.fullPath : `/${item.fullPath}`)
        : item.categorySlug
            ? `/${item.categorySlug}/${item.slug || ""}`
            : item.slug
                ? `/${item.slug}`
                : null;
    return {
        id: item.articleId ?? item.id ?? index,
        kb_id: item.articleId ?? item.kb_id,
        title: item.title ?? item.name,
        url: url || item.url,
    };
}

/**
 * AI/LLM search: POST article/ai-search. Routes via postRequest:
 *   - Public KB → public/v1/article/ai-search (no auth needed)
 *   - Internal KB → Bifrost (with session auth)
 * @param {{ query: string, product?: string, session_id?: string|null, conversation_history?: Array<{question:string, answer:string}> }} params
 * @returns {Promise<{ content: string, sources: any[] }>}
 */
export async function getAiSearchResponse({ query = "", product, session_id, conversation_history }) {
    const searchTerm = (query || "").trim();
    const body = { searchTerm };
    if (session_id != null) body.session_id = session_id;
    if (conversation_history != null) body.conversation_history = conversation_history;
    const params = product ? { product } : undefined;
    const res = await postRequest(apiRoutes.kbArticleAiSearch, body, params);
    let data = res?.data?.data ?? res?.data ?? res;
    if (Array.isArray(data)) data = data[0] ?? {};
    const searchResults = Array.isArray(data.search_results)
        ? data.search_results
        : [];
    let sources = normalizeSources(data);
    if (sources.length === 0 && searchResults.length > 0) {
        sources = searchResults.map((item, i) => searchResultToSource(item, i));
    }
    return {
        content: data.content ?? "",
        sources,
    };
}
